import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Select, SvgIcon } from 'components'
import { useSelector, useDispatch } from 'react-redux'
import { setAdvancedCalendar } from 'store/actions/calendar'
import { parseTimeOptions } from 'utils/calendar/advanced'
import { ReactComponent as IconArrowDown } from 'static/ic_arrow_down.svg'
import { colors } from 'constants/colors'

const useStyles = makeStyles({
  selectIcon: {
    fontSize: '1.5rem',
    position: 'absolute',
    right: 10,
    top: 8,
    zIndex: 0,
    color: colors.BASIC.COLOR[20],
  },
  select: {
    zIndex: 1,
  },
})

const ADVANSED_SCHEDULE = 'advanced_schedule'

const AdvancedSchedule = ({ handleLoading }) => {
  const classes = useStyles()
  const userSchedule = useSelector(state => state.calendar.advanced_calendar[ADVANSED_SCHEDULE])
  const scheduleOptions = useSelector(state => state.common.advancedSchedulesList)
  const dispatch = useDispatch()

  return (
    <Select
      options={parseTimeOptions(scheduleOptions)}
      variant="outlined"
      className={classes.selectWrapper}
      fullWidth
      disablePlaceholder
      value={userSchedule}
      onChange={e => {
        handleLoading(true)
        return dispatch(setAdvancedCalendar({ [ADVANSED_SCHEDULE]: e.target.value })).then(() => handleLoading(false))
      }}
      selectClasses={{ root: classes.select }}
      IconComponent={() => <SvgIcon component={IconArrowDown} viewBox="0 0 16 16" className={classes.selectIcon} />}
    />
  )
}

export default AdvancedSchedule
